module.exports = __webpack_public_path__ + "static/image2-e57d94ecbc70bfd0e7a581b4a26120fe.jpg";